"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../utils/validations");
function updateQuizMarksTotal({ marksTotal: existingMarksTotal }, session) {
    if (!(0, validations_1.isNumber)(existingMarksTotal)) {
        return session.marksTotal;
    }
    return Math.max(existingMarksTotal, session.marksTotal);
}
exports.default = updateQuizMarksTotal;
